document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
        const portfolios = document.querySelectorAll('.portfolio');

        portfolios.forEach((portfolio) => {
            const buttons = portfolio.querySelectorAll('.categoryTitles button');
            const categories = portfolio.querySelectorAll('.categoryContents .category');

            buttons.forEach((button, index) => {
                button.addEventListener('click', (e) => {

                    // Remove active class from all buttons and categories
                    buttons.forEach(btn => btn.classList.remove('active'));
                    categories.forEach(category => category.classList.remove('active'));

                    // Add active class to the clicked button and corresponding category
                    button.classList.add('active');
                    const activeCategory = categories[index];
                    activeCategory.classList.add('active');

                    // Hide all categories and then show the selected one with animation
                    categories.forEach((category, catIndex) => {
                        if (catIndex === index) {
                            showCategory(category);
                        } else {
                            hideCategory(category);
                        }
                    });
                });
            });
        });

        function showCategory(category) {
            category.classList.add('active');
        }

        function hideCategory(category) {
            category.classList.remove('active');
        }
    });
});
